import React from 'react';
import { connect } from 'react-redux';
import { patientActions } from '_actions';
import { bindActionCreators } from 'redux';
import { ExcelButton, RadioButton } from '_components';
import styles from './Common.module.css';
import { alService } from '_services';


class PatientCareCenterAlSelections extends React.Component {

    changeDisplayMode(mode) {
        this.props.changeAlDisplayMode({ epno: this.props.epno, mode });
    }

    openAl() {
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);

        alService.raw(this.props.epno)
            .then(response => response.blob())
            .then(blobby => {
                let objectUrl = window.URL.createObjectURL(blobby);
                anchor.href = objectUrl;
                anchor.click();

                window.URL.revokeObjectURL(objectUrl);

            });
    }

    render() {
        return (
            <div className={styles.selections_wrapper}>
                <RadioButton
                    size='extra-small'
                    className={styles.radio}
                    label='All Visits'
                    onClick={() => this.changeDisplayMode(-1)}
                    selected={this.props.displayMode === -1}
                />
                <RadioButton
                    size='extra-small'
                    className={styles.radio}
                    label='6 Visits'
                    onClick={() => this.changeDisplayMode(6)}
                    selected={this.props.displayMode === 6}
                />
                <RadioButton
                    size='extra-small'
                    className={styles.radio}
                    label='3 Visits'
                    onClick={() => this.changeDisplayMode(3)}
                    selected={this.props.displayMode === 3}
                />
                <span className={styles.excel}>
                    <ExcelButton onClick={() => this.openAl()} />
                </span>
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        changeAlDisplayMode: bindActionCreators(patientActions.changeAlDisplayMode, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    let displayMode = state.ui.al[ownprops.epno].displayMode;

    return {
        displayMode
    };
}

const connectedPatientCareCenterAlSelections = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterAlSelections);
export { connectedPatientCareCenterAlSelections as PatientCareCenterAlSelections };

